import React from 'react';
import AuthComponent from '../Components/Auth/AuthComponent';

const AuthPage = () => {
  return (
    <div>
      <AuthComponent />
    </div>
  );
};

export default AuthPage;
